//^ done in Co Reducer
export const orderStyleFormatterForMultiStyle = (orderStyles) => {
    let pOrderNumber;
    const formattedData = {};
    const sizeQuantities = {};
    const poSizes = {};
    const poColors = {};
    //handle old data in db
    let styles = orderStyles;
    if (!Array.isArray(orderStyles)) {
        styles = orderStyles?.orderStyles;
    }
    styles?.forEach((item) => {
        pOrderNumber =
            orderStyles?.order?.order_number ?? item.order?.order_number;

        // Create unique keys by concatenating orderStyleId
        const uniqueColorId = `${pOrderNumber}_${item.color._id}`;
        const uniqueSizeId = `${pOrderNumber}_${item.size._id}`;
        // Format data with unique color key
        // Deep clone the sizes object to avoid reference issues
        const prevSizes = formattedData[uniqueColorId]?.sizes
            ? { ...formattedData[uniqueColorId].sizes }
            : {};

        formattedData[uniqueColorId] = {
            ...(formattedData[uniqueColorId] || {}),
            ...item.color,
            quantity:
                (formattedData[uniqueColorId]?.quantity || 0) + item.quantity,
            sizes: {
                ...prevSizes,
                [item.size._id]: {
                    ...item.size,
                    quantity: item.quantity,
                },
            },
        };

        // Use unique size ID for quantities
        sizeQuantities[uniqueSizeId] =
            (sizeQuantities[uniqueSizeId] || 0) + item.quantity;

        // Store sizes with unique IDs
        if (!poSizes[uniqueSizeId]) {
            poSizes[uniqueSizeId] = {
                ...item.size,
                _id: uniqueSizeId,
            };
        }

        // Store colors with unique IDs
        if (!poColors[uniqueColorId]) {
            poColors[uniqueColorId] = {
                ...item.color,
            };
        }
    });

    return {
        formattedData,
        sizeQuantities,
        poSizes,
        poColors,
    };
};

export const poDataColorsSizes = (
    orderStyles,
    orderStylesProperty = 'order_styles',
    isMultiStyle = false,
) => {
    if (!orderStyles) return;

    const { formattedData, sizeQuantities, poColors, poSizes } = isMultiStyle
        ? orderStyleFormatterForMultiStyle(orderStyles[orderStylesProperty])
        : orderStyleFormatter(orderStyles[orderStylesProperty]);

    const poData = {
        formattedData,
        sizeQuantities,
        ...orderStyles,
    };

    const sizesArray = Object.values(poSizes);
    const colorsArray = Object.keys(poColors).map((colorId) => ({
        _id: colorId,
        name: poColors[colorId].name,
    }));

    return { poData, sizesArray, colorsArray };
};

export const orderStyleFormatter = (orderStyles) => {
    const formattedData = {};
    const sizeQuantities = {};
    const poSizes = {};
    const poColors = {};

    orderStyles.forEach((item) => {
        formattedData[item.color._id] = {
            ...formattedData[item.color._id],
            ...item.color,
            quantity:
                (formattedData[item.color._id]?.quantity || 0) + item.quantity,
            sizes: {
                ...formattedData[item.color._id]?.sizes,
                [item.size._id]: {
                    ...item.size,
                    quantity: item.quantity,
                },
            },
        };
        sizeQuantities[item.size._id] =
            (sizeQuantities[item.size._id] || 0) + item.quantity;
        if (!poSizes[item.size._id]) poSizes[item.size._id] = item.size;
        if (!poColors[item.color._id]) poColors[item.color._id] = item.color;
    });

    return { formattedData, sizeQuantities, poSizes, poColors };
};
